module.exports = __webpack_public_path__ + "img/logo-white.6ba4f0d3.svg";